module.exports = __webpack_public_path__ + "static/media/de_mirage.48a00793.svg";